import { ROUTES } from "@/@core/constants/routes";
import { useHeader } from "@/hooks/headerContext";
import { useNearbyVenue } from "@/hooks/nearbyVenueContext";
import { useTranslation } from "@/hooks/translationContext";
import { useSite } from "@/lib/hooks/site";
import { usePathname } from "next/navigation";

export default function SearchResultDescription() {
  const site = useSite();
  const { t } = useTranslation();
  const { district, service, dataCount } = useHeader();
  const { nearbyVenuesCount, venueCount } = useNearbyVenue();
  const currentPathname = usePathname();

  const i18nTags = () => {
    return {
      service: service?.title,
      city: site.city_relation.title,
      district: district?.title,
      totalVenueCount: venueCount + nearbyVenuesCount,
      nearbyVenueCount: nearbyVenuesCount,
      venueCount: venueCount,
      totalCampaignCount: dataCount?.nearby?.campaigns + dataCount?.campaigns,
    };
  };

  const getDescriptionKey = (type) => {
    if (district?.id && service?.id) return `${type}-district-and-service-description`;
    if (district?.id) return `${type}-district-description`;
    if (service?.id) return `${type}-service-description`;
    return null;
  };

  const getTitleKey = () => {
    if (currentPathname.includes(ROUTES.CAMPAIGNS)) {
      return getDescriptionKey("campaign-search-result");
    }

    if (currentPathname.includes(ROUTES.EVENTS)) {
      return getDescriptionKey("event-search-result");
    }

    if (currentPathname.includes(ROUTES.ALL_COMPANIES)) {
      return null;
    }

    return getDescriptionKey("search-result");
  };

  const titleKey = getTitleKey();
  if (!titleKey) return null;

  const translatedText = t(titleKey, i18nTags);
  if (!translatedText || translatedText === titleKey) return null;

  return titleKey ? (
    <div className="container pt-2 pb-4">
      <h2
        className="text-[#212a3e] text-sm font-medium leading-6 tracking-[0.8px] text-left"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        {t(titleKey, i18nTags())}
      </h2>
    </div>
  ) : null;
}
